export default __webpack_public_path__ + "static/Hospitality_restaurant-9c1bc454c2a51574b5bc391873f5020f.png";